var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Home"}},[_c('HeroSlider',{attrs:{"sliderImages":_vm.sliderImages}}),_c('WhyGroupTickets'),_c('PartyAreas'),_c('GroupSeating'),_c('Schedule'),_c('BookSuiteForm'),_c('Suites')],1)}
var staticRenderFns = []

export { render, staticRenderFns }